import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

import type { BadgeColor } from './badge.types';
import type { IconName } from '../../common/icon/icons.type';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.less', './badge-overwrites.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color()',
  },
  imports: [IconComponent, NgTemplateOutlet],
})
export class BadgeComponent {
  public readonly color = input<BadgeColor>(undefined!);
  public readonly iconTmplContext = input<Record<string, any> | null>();
  public readonly text = input<string | number>(undefined!);

  @Input() public iconName: IconName;
  @Input() public iconTmpl?: TemplateRef<any> | null;
  @Input() public contentTpl?: TemplateRef<any> | null = null;
}
